import useUser from '@hooks/auth/useUser';
import NativeUtil from '@utils/NativeUtil';
import { useEffect } from 'react';

function useRegisterToken() {
  const { user } = useUser();
  useEffect(() => {
    if (user) {
      NativeUtil.postMessage('registerToken', user.id);
    }
  }, [user]);
}
export default useRegisterToken;
